// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createCheckoutSessionsCheckoutSessions = (client) => ({
    /**
     * `POST /checkout_sessions/:id/cancel`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId CheckoutSessionsCheckoutSessionsIdCancelCreate
     * @source apps/backend/src/api/checkout_sessions/[id]/cancel/route.ts
     */
    cancel: (id, body, query, headers) => client.fetch(buildPath("/checkout_sessions/:id/cancel", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /checkout_sessions/:id/complete`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId CheckoutSessionsCheckoutSessionsIdCompleteCreate
     * @source apps/backend/src/api/checkout_sessions/[id]/complete/route.ts
     */
    complete: (id, body, query, headers) => client.fetch(buildPath("/checkout_sessions/:id/complete", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /checkout_sessions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId CheckoutSessionsCheckoutSessionsCreate
     * @source apps/backend/src/api/checkout_sessions/route.ts
     */
    create: (body, query, headers) => client.fetch("/checkout_sessions", { method: "POST", body, query, headers }),
    /**
     * `GET /checkout_sessions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId CheckoutSessionsCheckoutSessionsIdRetrieve
     * @source apps/backend/src/api/checkout_sessions/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/checkout_sessions/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /checkout_sessions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId CheckoutSessionsCheckoutSessionsIdCreate
     * @source apps/backend/src/api/checkout_sessions/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/checkout_sessions/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=checkout_sessions.js.map